import React, { useEffect } from 'react';

// eslint-disable-next-line import/no-unresolved
import useStore from 'playbook-web/store';

import { createWebSocketConsumer } from '../index';
import { getFunctions } from '../../core/hooks/use-function-handler';

const CompanyChannel = () => {
  const token = useStore((state) => state.token);
  const companyId = useStore((state) => state.company)?.id;

  useEffect(() => {
    if (!token || !companyId) {
      return;
    }
    const consumer = createWebSocketConsumer(token);

    const channel = consumer.subscriptions.create(
      {
        channel: 'CompanyChannel',
        company_id: companyId,
      },
      {
        connected() {
          console.log('Connected to CompanyChannel');
        },
        disconnected() {
          console.log('Disconnected from CompanyChannel');
        },
        rejected() {
          console.log('Subscription to CompanyChannel was rejected');
        },
        received(data) {
          const group = getFunctions(data.group);
          // do nothing if group is empty
          if (!group) return;

          Object.values(group).forEach((func) => (data.payload ? func(data.payload) : func()));
        },
      },
    );

    // eslint-disable-next-line consistent-return
    return () => {
      if (channel) {
        channel.unsubscribe();
      }
    };
  }, [token, companyId]);

  return null;
};

export default React.memo(CompanyChannel);
